import PropTypes from "prop-types";
import Button from "../Button";
import ArrowRightWhite from "/public/images/icons/arrowRightWhite.svg?react";
import { Link } from "react-router-dom";

export default function BandCard({ band, participant, type, href, size, tempImage, triggerModal, label }) {

  if (band) {
    const gradient =  
      band.BandColour === "RED"
        ? "#A4123F"
      : band.BandColour === "BLUE"
        ? "#1877D3"
      : band.BandColour === "GREY"
        ? "#727272"
      : band.BandColour === "BLACK"
        ? "#101820"
      : band.BandColour === "YELLOW"
        ? "#EAAA00"
      : "#F8F8F8";

    return (
      <Link
        to={href}
        className={`${size === "sm" && "max-h-[128px]"}`}
        state={{ band: band, participant: participant }}
      >
        <div
          className={`border-[1px] border-[#E3E3E3] rounded-[4px] mr-5`}
          style={{
            background: `${gradient}`,
          }}
        >
          <div
            className={`flex flex-col px-6 ${
              size !== "sm" ? "py-5" : ""
            } h-full rounded-[4px]`}
            style={{
              background: `linear-gradient(151.5deg, rgba(255,255,255, 0.1) 0%, rgba(255,255,255, 0.1) 50%, ${gradient} 50.1%, ${gradient} 100%)`,
            }}
          >
            <div className="flex h-full justify-between">
              <div
                className={`flex flex-col ${band?.IsGuestBand ? "gap-y-2" : "gap-y-3"} justify-center z-10 basis-[202px]`}
              >
                {!band?.IsGuestBand ? (
                  tempImage ? (
                    <img src={tempImage} width="40" height="40" alt="avatar" className="rounded-full object-cover w-10 h-10" />
                  ) : participant?.ProfilePicture ? (
                    <img src={participant?.ProfilePicture + `?t=${Date.now()}`} width="40" height="40" alt="avatar" className="rounded-full object-cover w-10 h-10" />
                  ) : (
                    <img
                      src="/images/default-avatar.svg"
                      width="40"
                      height="40"
                      alt="default avatar"
                    />
                  )
                ) : ( <h5 className="text-white">{band?.FriendlyName}</h5> )}
                
                {size !== "sm" && (
                  <p className="text-base font-medium leading-[26px] text-white">
                    {type === 'participant' ? `${participant?.ParticipantName}'s Profile` : `${participant?.ParticipantName}'s Band`}
                  </p>
                )}

                {participant?.TransferPending ? (
                  <p className="hover:select-none text-[12px] color-[#1E1E1E] leading-6 bg-white rounded-[4px] pl-[11.8px] pr-[9.5px] tracking-[2.4px] uppercase font-semibold self-start w-fit">
                    Transferring
                  </p>
                ) : null}

                {(!participant?.TransferPending && band?.BandStateVerbose) ? (
                  <p className={`
                    hover:select-none text-[11px] color-[#1E1E1E] leading-6 bg-white rounded-[4px] pl-[9px] pr-[6.5px] tracking-[2px] uppercase font-semibold self-start w-fit
                    ${(band?.BandStateVerbose === "PERMANENTLY DISABLED" && !label) && "tracking-[1px]"}
                  `}>
                    {label ? label : band?.BandStateVerbose}
                  </p>
                ) : null}
              </div>
              <div className="flex flex-col items-end h-full justify-end">
                <img
                  src={band?.BandImageURL}
                  alt="band"
                  className="max-w-[175px] mr-[-48px]"
                />
                {band.status !== "checked-in" && size !== "sm" && (
                  <ArrowRightWhite className="mt-[-10px]" />
                )}
              </div>
            </div>
            {band.status === "checked-in" && size !== "sm" && (
              <div className="flex justify-between items-center border-t-[1px] border-t-solid border-t-[#E3E3E3] pt-5 mt-5">
                <p className="medium text-base leading-[25px] text-white">
                  1 Activity in Progress
                </p>
                <ArrowRightWhite />
              </div>
            )}
          </div>
        </div>
      </Link>
    );
  }

  return (
    <div className="bg-[#F8F8F8] border-[1px] border-[#E3E3E3] h-[200px] rounded-[4px] mr-5 relative flex items-center p-3">
      <Button
        onClick={() => triggerModal()}
        variant="primary"
      >
        Activate Band
      </Button>
      <img
        src="/images/grey-band.png"
        alt="band"
        className="max-w-[175px] mx-auto right-[-20px] absolute"
      />
    </div>
  );
}

BandCard.propTypes = {
  band: PropTypes.object,
  participant: PropTypes.object,
  href: PropTypes.string,
  size: PropTypes.string,
  status: PropTypes.string,
  triggerModal: PropTypes.func,
};
